import normalizeBreakpointsArray from "./normalizeBreakpointsArray";
var expandVariants = function(variant, themeObject) {
    return function(param) {
        var theme = param.theme;
        if (!variant) {
            return null;
        }
        if (Array.isArray(variant)) {
            var normalizedValue = normalizeBreakpointsArray(variant, theme);
            return normalizedValue.map(function(v, i) {
                if (v && themeObject[v]) {
                    return theme.normalizeStyles(themeObject[v], theme.viewportsArray[i]);
                }
                return false;
            }).filter(Boolean);
        } else if (themeObject[variant]) {
            return theme.normalizeStyles(themeObject[variant]);
        }
        return null;
    };
};
export default expandVariants;
